export const useUrlPremium = () => {
  const runtimeConfig = useRuntimeConfig();

  const baseUrl = computed(() => `${runtimeConfig.public.eva1Url}/premium`);

  const getUrlWithUtm = (
    utmMedium: string,
    utmCampaign: string,
    utmContent?: string
  ) => {
    let url = `${baseUrl.value}?utm_source=web&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
    if (utmContent != null) url += `&utm_content=${utmContent}`;
    return url;
  };

  const urlFromHomeFamilySubscribe = computed(() => {
    return getUrlWithUtm('page_famille', 'subscribe_page_famille');
  });

  const getUrlFromPackWithChildrenType = (chindrenType?: ChildrenTypes) => {
    return getUrlWithUtm('page_pack', 'subscribe_page_pack', chindrenType);
  };

  const urlFromPack = computed((chindrenType?: ChildrenTypes) => {
    return getUrlWithUtm('page_pack', 'subscribe_page_pack', chindrenType);
  });

  const urlDialogFamilySubscribe = computed(() => {
    return getUrlWithUtm(
      'pop_up_contenus_bloques_parents',
      'subscribe_page_famille',
      'bouton_abonnement'
    );
  });

  return {
    baseUrl,
    urlFromHomeFamilySubscribe,
    urlFromPack,
    urlDialogFamilySubscribe,
    getUrlFromPackWithChildrenType,
  };
};
